import { Box, Tabs, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface ManagementTabsProps {
  activeTab: 0 | 1;
}

export function ManagementTabs({ activeTab }: ManagementTabsProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
      <Tabs
        value={activeTab}
        onChange={(_, v) => navigate(v === 0 ? "/projects" : "/clients")}
      >
        <Tab label={t("nav.projects")} sx={{ fontWeight: 600 }} />
        <Tab label={t("nav.clients")} sx={{ fontWeight: 600 }} />
      </Tabs>
    </Box>
  );
}
